import {EAIClient} from "Services/EAIClient";
import {observable, flow, makeObservable} from "mobx";
import {appStore} from "Stores/index";
import {Utils} from "../../common/utils"


export const enum MilestoneStatus {
    INCOMPLETE = "INCOMPLETE",
    COMPLETE = "COMPLETE"
}

export interface Milestone {
    ruuid: string,
    due_date: Date | null,
    description: string,
    status: MilestoneStatus,
    actionplan_id: string,
    school_id: string,
    completed_at: Date | null
    completed_by_name: string | null | undefined
}

export class MilestoneStore {
    client = new EAIClient();

    @observable milestones: Milestone[] = [];
    @observable isFetchingMilestones = false;
    @observable isAddingMilestone = false;
    @observable isUpdatingMilestone = false;
    @observable isUpdatingStatusMilestone = false;
    @observable isDeletingMilestone = false;

    constructor() {
        makeObservable(this);
    }

    @flow
    * addMilestoneToActionPlan(actionPlanId: string, description: string, dueDate: Date | undefined | null): any {
        this.isAddingMilestone = true;
        try {
            const dueDateFormat = dueDate ? Utils.formatDate(dueDate, "YYYY-MM-DD") : dueDate;
            yield this.client.addMilestoneToActionPlan(actionPlanId, description, dueDateFormat);
        } catch (e) {
            appStore.addError(e);
        } finally {
            this.isAddingMilestone = false;
        }
    }

    @flow
    * getAllMilestonesForActionPlan(actionPlanId: string): any {
        this.isFetchingMilestones = true;
        try {
            const resp = yield this.client.getAllMilestonesForActionPlan(actionPlanId);
            const tempMilestones = resp.data.data as Milestone[];
            this.milestones = tempMilestones.map(milestone => {
                let dueDate;
                if (milestone.due_date) {
                    dueDate = Utils.parseISOLocalDate(milestone.due_date.toString());
                }
                return {
                    ...milestone,
                    due_date: dueDate ? dueDate : null,
                    completed_at: milestone.completed_at ? new Date(milestone.completed_at) : null,
                };
            });
            return this.milestones;
        } catch (e) {
            appStore.addError(e);
        } finally {
            this.isFetchingMilestones = false;
        }
    }

    @flow
    * updateMilestoneForActionPlan(actionPlanId: string, ruuid: string, status: string, description: string, dueDate: Date | undefined | null): any {
        this.isUpdatingMilestone = true;
        try {
            const dueDateFormat = dueDate ? Utils.formatDate(dueDate, "YYYY-MM-DD"): dueDate;
            yield this.client.updateMilestoneForActionPlan(actionPlanId, ruuid, status, description, dueDateFormat);
        } catch (e) {
            appStore.addError(e);
        } finally {
            this.isUpdatingMilestone = false;
        }
    }

    @flow
    * updateStatusMilestoneForActionPlan(actionPlanId: string, ruuid: string, status: string): any {
        this.isUpdatingStatusMilestone = true;
        try {
            yield this.client.updateStatusMilestoneForActionPlan(actionPlanId, ruuid, status);
        } catch (e) {
            appStore.addError(e);
        } finally {
            this.isUpdatingStatusMilestone = false;
        }
    }

    @flow
    * deleteMilestoneForActionPlan(actionPlanId: string, ruuid: string): any {
        this.isDeletingMilestone = true;
        try {
            yield this.client.deleteMilestoneForActionPlan(actionPlanId, ruuid);
        } catch (e) {
            appStore.addError(e);
        } finally {
            this.isDeletingMilestone = false;
        }
    }
}